import { useTranslation } from 'react-i18next'

import { usePathParams } from '~/apps/ninesegsAnalyzer/routes/paths'
import { ensureExists } from '~/utils'

import { pathKey } from '../utils'

export const useCustomerAttributeGroupId = () => {
  const { t } = useTranslation()
  const { customerAttributeGroupId } = usePathParams(pathKey)

  return ensureExists(customerAttributeGroupId, t('assertion_failed'))
}
